import { Api } from '@axiom/ui';
import type {
  CalendarConversationType,
  MeetingLinkType,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CalendarConversationsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async updateTime(
    conversationId: CalendarConversationType['id'],
    body: { startTime: string; endTime: string }
  ) {
    return super.write<{
      data: null;
    }>({
      endpoint: `/calendarConversations/${conversationId}/time`,
      method: 'PATCH',
      body,
    });
  }

  async updateConversation(
    conversationId: CalendarConversationType['id'],
    body: {
      addContactIds?: string[];
      addAdhocAttendees?: Array<{
        firstName: string;
        lastName: string;
        email: string;
      }>;
      removeEventIds?: string[];
      meetingUrl?: string | null;
      meetingLinkType?: MeetingLinkType;
    }
  ) {
    return super.write<{
      data: null;
    }>({
      endpoint: `/calendarConversations/${conversationId}`,
      method: 'PATCH',
      body,
    });
  }

  async deleteInterviewRequest(clientRequestId: string) {
    return super.write<{
      data: null;
    }>({
      endpoint: `/clientRequests/${clientRequestId}/interviewRequest`,
      method: 'DELETE',
    });
  }
}

export const CalendarConversationsApi = new CalendarConversationsApiClass();
